/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_Up_FreeInputs */

const en_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up free`)
};

const es_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate gratis`)
};

const fr_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrivez-vous gratuitement`)
};

const de_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos registrieren`)
};

const ja_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で登録`)
};

const zh_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费注册`)
};

const ar_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل مجاناً`)
};

const id_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar gratis`)
};

const it_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti gratis`)
};

const ru_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрироваться бесплатно`)
};

const pt_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscreva-se grátis`)
};

const ko_sign_up_free = /** @type {(inputs: Sign_Up_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료로 가입하기`)
};

/**
* | output |
* | --- |
* | "Sign up free" |
*
* @param {Sign_Up_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sign_up_free = /** @type {((inputs?: Sign_Up_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_Up_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sign_up_free(inputs)
	if (locale === "es") return es_sign_up_free(inputs)
	if (locale === "fr") return fr_sign_up_free(inputs)
	if (locale === "de") return de_sign_up_free(inputs)
	if (locale === "ja") return ja_sign_up_free(inputs)
	if (locale === "zh") return zh_sign_up_free(inputs)
	if (locale === "ar") return ar_sign_up_free(inputs)
	if (locale === "id") return id_sign_up_free(inputs)
	if (locale === "it") return it_sign_up_free(inputs)
	if (locale === "ru") return ru_sign_up_free(inputs)
	if (locale === "pt") return pt_sign_up_free(inputs)
	return ko_sign_up_free(inputs)
});